export default "__VITE_ASSET__WJT9ISOX__"